import React, { useState } from "react";

import Form from "@Components/Form";
import { URLS, BO_USER_URL } from "configs/constants";
import { SOURCE_FETCH_URL } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";
import AllowableEstateDetails from "./AllowableEstateDetails";

const initialValues = {
  id_type: "",
  id_number: "",
  name: "",
  username: "",
  role: [],
  status: [],
  mobile_number: "",
  employee_id: "",
  zone: "",
  region: "",
  estate: "",
  block: "",
  nationality: "",
  email: "",
  division: "",
  office_number: "",
  department: "",
  designation: "",

  is_hq: false,
  zones: [],
  regions: [],
  estates: [],
  all_estates: false,
};

const BackOfficeUserDetail = () => {

  const [showAllowables, setShowAllowables] = useState(false);
  const [allowables, setAllowables] = useState([]);
  const formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "name",
      key: "name",
      label: "Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_type_name",
      key: "id_type_name",
      label: "ID Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_number",
      key: "id_number",
      label: "ID Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      type: "renderonly",
      name: "designation",
      key: "designation",
      label: "Designation",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      type: "renderonly",
      name: "department",
      key: "department",
      label: "Department",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "email",
      key: "email",
      label: "Email",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "office_number",
      key: "office_number",
      label: "Office Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_number",
      key: "mobile_number",
      label: "Mobile Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "is_hq",
      key: "is_hq",
      label: "HQ?",
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      name: "api",
      key: "api",

      type: "renderonly",
      label: "API",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",


    },
    {
      type: "renderonly",
      name: "source_name",
      key: "source_name",
      label: "Source",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "company_name",
      key: "company_name",
      label: "Company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },


    { type: "title", title: "Employment Details" },
    {
      type: "renderonly",
      name: "roles_name",
      key: "roles_name",
      label: "Roles",
      isMulti: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    
    {
      type: "renderonly",
      name: "zone_name",
      key: "zone_name",
      label: "Zone",
    },
    {
      type: "renderonly",
      name: "region_name",
      key: "region_name",
      label: "Region",
    },
    {
      type: "renderonly",
      name: "estate_name",
      key: "estate_name",
      label: "Estate",
    },
    {
      type: "renderonly",
      name: "division_name",
      key: "division_name",
      label: "Division",
    },
    {
      type: "renderonly",
      name: "block_name",
      key: "block_name",
      label: "Block",
    },

    { type: "title", title: "Allowables Estate" },

  
    {
      type: "component",
      component: AllowableEstateDetails,
      allowables: allowables,
      setAllowables: setAllowables,
      gridSize: { xs: 12 },
      renderOnly: true,


    },
  ];

  const formButtons = ["cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={BO_USER_URL}
      listRoute={URLS.BO_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Back-Office User"
    />
  );
};

export default BackOfficeUserDetail;
